// @flow
import * as React from 'react';
import Container from './Container';
import TextStrong from './TextStrong';

import TextSmall from './TextSmall';
import VerifiableAccount from '../lib/VerifiableAccount';
import ButtonIcon from './ButtonIcon';

type TProps = {
  account: VerifiableAccount,
  onClick: (account: VerifiableAccount) => void,
};

export default function ListItemVerifiableAccount(props: TProps): React.Node {
  const { onClick, account } = props;

  const on_click = () => {
    if (!account.is_verified()) onClick(account);
  };

  return (
    <Container flex justify="space-between" align="center" px={24} py={16} onClick={on_click}>
      <Container flex align="center">
        <Container flex="column">
          {account.name}
          <TextSmall color="#4b4b4b">ending in **{account.mask}</TextSmall>
        </Container>
      </Container>

      {/* Verify Button */}
      {account.is_verified() && (
        <Container flex centered>
          <Container mr={8}>
            <TextSmall>
              <TextStrong color="green">Verified</TextStrong>
            </TextSmall>
          </Container>
          <ButtonIcon name="check-circle-fill" color="green" />
        </Container>
      )}
      {!account.is_verified() && (
        <Container flex centered px={8} py={8} fill="#e0e0e0">
          <Container mr={8}>
            <TextSmall>
              <TextStrong>Verify</TextStrong>
            </TextSmall>
          </Container>
          <ButtonIcon name="chevron-right" />
        </Container>
      )}
    </Container>
  );
}
